import { Installation } from "../Installation";
import { InstalledSoftware } from "../InstalledSoftware";
import { ConfigurationComparisonEnum } from "../enums/ConfigurationComparisonEnum";
import { StocksProfileEnum } from "../enums/StocksProfileEnum";
import { UpdateTypeEnum } from "../enums/UpdateTypeEnum";
import { ConfigurationSecurity } from "./ConfigurationSecurity";

export class RollProfile {
    rollsNumber: number;
    hasBag: boolean;
    rollMaxPieces: number;
    bagMaxPieces: number;

    public parse(obj: any) {
        if (obj.RollsNumber != null && obj.RollsNumber != undefined) this.rollsNumber = obj.RollsNumber;
        if (obj.HasBag != null && obj.HasBag != undefined) this.hasBag = obj.HasBag;
        if (obj.RollMaxPieces != null && obj.RollMaxPieces != undefined) this.rollMaxPieces = obj.RollMaxPieces;
        if (obj.BagMaxPieces != null && obj.BagMaxPieces != undefined) this.bagMaxPieces = obj.BagMaxPieces;
    }

    public static StockToRollProfile(stockProfile: StocksProfileEnum): RollProfile {
        switch (stockProfile) {
            case StocksProfileEnum.NT8R1B: {
                let r = new RollProfile();
                r.rollsNumber = 8;
                r.hasBag = true;
                return r;
            }
            case StocksProfileEnum.NT1B: {
                let r = new RollProfile();
                r.rollsNumber = 0;
                r.hasBag = true;
                return r;
            }
            case StocksProfileEnum.NT1R1B: {
                let r = new RollProfile();
                r.rollsNumber = 1;
                r.hasBag = true;
                return r;
            }
            case StocksProfileEnum.NT2R1B: {
                let r = new RollProfile();
                r.rollsNumber = 2;
                r.hasBag = true;
                return r;
            }
            case StocksProfileEnum.NT3R1B: {
                let r = new RollProfile();
                r.rollsNumber = 3;
                r.hasBag = true;
                return r;
            }
            case StocksProfileEnum.NT4R1B: {
                let r = new RollProfile();
                r.rollsNumber = 4;
                r.hasBag = true;
                return r;
            }
            case StocksProfileEnum.NT5R1B: {
                let r = new RollProfile();
                r.rollsNumber = 5;
                r.hasBag = true;
                return r;
            }
            case StocksProfileEnum.NT8R: {
                let r = new RollProfile();
                r.rollsNumber = 8;
                r.hasBag = false;
                return r;
            }
            case StocksProfileEnum.NT12R: {
                let r = new RollProfile();
                r.rollsNumber = 12;
                r.hasBag = false;
                return r;
            }
            case StocksProfileEnum.NT16R: {
                let r = new RollProfile();
                r.rollsNumber = 16;
                r.hasBag = false;
                return r;
            }
        }
    }
}

export class InstallationStocksConfiguration extends Installation {
    securityConfigurationActual: ConfigurationSecurity = null;
    securityConfigurationReference: ConfigurationSecurity = null;
    scheduled: boolean = false;
    comparisonStatus: ConfigurationComparisonEnum = null;
    agent: Array<InstalledSoftware> = null;
    rollsProfile: RollProfile = null;

    constructor() {
        super();
    }

    public parse(obj: any) {
        super.parse(obj);
        if (obj.SecurityConfigurationActual) {
            this.securityConfigurationActual = new ConfigurationSecurity();
            this.securityConfigurationActual.parse(obj.SecurityConfigurationActual);
        }

        if (obj.SecurityConfigurationReference) {
            this.securityConfigurationReference = new ConfigurationSecurity();
            this.securityConfigurationReference.parse(obj.SecurityConfigurationReference);
        }

        if (obj.Scheduled != null && obj.Scheduled != undefined) this.scheduled = obj.Scheduled;
        if (obj.ComparisonStatus != null && obj.ComparisonStatus != undefined) this.comparisonStatus = obj.ComparisonStatus;

        if (obj.AgentInfo && obj.AgentInfo.Version) {
            this.agent = new Array<InstalledSoftware>();
            let agentSoftware = new InstalledSoftware();
            agentSoftware.name = "Agent";
            agentSoftware.version = obj.AgentInfo.Version;
            agentSoftware.updateType = UpdateTypeEnum.Agent;
            this.agent.push(agentSoftware);
        }

        if (obj.RollsProfile != null && obj.RollsProfile != undefined) {
            this.rollsProfile = new RollProfile();
            this.rollsProfile.parse(obj.RollsProfile);
        }
    }
}
